<template>
    <div class="consultation-manage">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>咨询管理</span>
            </div>

            <!-- 搜索区域 -->
            <div class="search-area">
                <el-input v-model="searchKeyword" placeholder="请输入姓名、联系方式或问题描述搜索" style="width: 300px; margin-right: 10px"
                    clearable @keyup.enter.native="handleSearch">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                
                <!-- 状态筛选 -->
                <el-select v-model="statusFilter" placeholder="请选择状态" clearable style="width: 120px; margin-right: 10px" @change="handleStatusChange">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="未处理" :value="0"></el-option>
                    <el-option label="已处理" :value="1"></el-option>
                </el-select>
                
                <el-button type="primary" @click="handleSearch">搜索</el-button>
                <el-button @click="resetSearch">重置</el-button>

                <!-- 添加咨询按钮 -->
                <!-- <el-button type="primary" @click="handleAddConsultation" style="margin-left: auto">
                    添加咨询
                </el-button> -->
            </div>

            <!-- 咨询表格 -->
            <el-table :data="consultationList" style="width: 100%; margin-top: 20px" v-loading="loading" border stripe>
                                <el-table-column type="index" label="序号" width="60" align="center">
                    <template slot-scope="scope">
                        {{ (scope.$index + 1) }}
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="id" label="序号" width="60" align="center">
                </el-table-column> -->
                <el-table-column prop="name" label="姓名" width="120" align="center">
                </el-table-column>
                <el-table-column prop="contact" label="联系方式" width="200" align="center">
                </el-table-column>
                <el-table-column prop="problemDescription" label="问题描述" align="center" >
                    <template slot-scope="scope">
                        <div class="problem-description-preview">
                            {{ scope.row.problemDescription ? scope.row.problemDescription.substring(0, 50) + (scope.row.problemDescription.length > 50 ? '...' : '') : '' }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="subjectName" label="主体名称"  align="center">
                </el-table-column>
                <el-table-column prop="consultationTime" label="咨询时间" width="180" align="center">
                </el-table-column>
                <el-table-column prop="status" label="状态" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status === 1 ? 'success' : 'warning'" size="small">
                            {{ scope.row.status === 1 ? '已处理' : '未处理' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="handleView(scope.row)">
                            查看
                        </el-button>
                        <el-button 
                            v-if="scope.row.status === 0" 
                            type="success" 
                            size="mini" 
                            @click="handleProcess(scope.row)">
                            处理
                        </el-button>
                        <el-button 
                            v-else
                            type="info" 
                            size="mini" 
                            disabled>
                            已处理
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="pagination-container">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pagination.currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pagination.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pagination.total">
                </el-pagination>
            </div>
        </el-card>

        <!-- 添加/查看咨询对话框 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" @close="handleDialogClose" :close-on-click-modal="false">
            <el-form ref="consultationForm" :model="consultationForm" :rules="rules" label-width="100px">
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="consultationForm.name" placeholder="请输入姓名" :disabled="isViewMode"></el-input>
                </el-form-item>
                <el-form-item label="联系方式" prop="contact">
                    <el-input v-model="consultationForm.contact" placeholder="请输入联系方式" :disabled="isViewMode"></el-input>
                </el-form-item>
                <el-form-item label="问题描述" prop="problemDescription">
                    <el-input v-model="consultationForm.problemDescription" type="textarea" :rows="4" placeholder="请输入问题描述" :disabled="isViewMode"></el-input>
                </el-form-item>
                <el-form-item label="主体名称" prop="subjectName">
                    <el-input v-model="consultationForm.subjectName" placeholder="请输入主体名称" :disabled="isViewMode"></el-input>
                </el-form-item>
                <el-form-item label="咨询时间" prop="consultationTime">
                    <el-date-picker
                        v-model="consultationForm.consultationTime"
                        type="datetime"
                        placeholder="选择咨询时间"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 100%"
                        :disabled="isViewMode">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="状态" v-if="isViewMode">
                    <el-tag :type="consultationForm.status === 1 ? 'success' : 'warning'" size="medium">
                        {{ consultationForm.status === 1 ? '已处理' : '未处理' }}
                    </el-tag>
                </el-form-item>
                
                <!-- 新增：处理结果显示 -->
                <el-form-item label="处理结果" v-if="isViewMode && consultationForm.status === 1">
                    <el-input 
                        v-model="consultationForm.result" 
                        type="textarea" 
                        :rows="4" 
                        :disabled="true"
                        placeholder="暂无处理结果">
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">关 闭</el-button>
                <el-button v-if="!isViewMode" type="primary" @click="submitConsultationForm">确 定</el-button>
            </span>
        </el-dialog>


            <!-- 处理咨询对话框 -->
        <el-dialog 
            title="处理咨询" 
            :visible.sync="processDialogVisible" 
            :close-on-click-modal="false"
            width="600px" 
            @close="handleProcessDialogClose">
            <el-form ref="processForm" :model="processForm" :rules="processRules" label-width="100px">
                <el-form-item label="姓名">
                    <el-input v-model="processForm.name" disabled></el-input>
                </el-form-item>
                <el-form-item label="联系方式">
                    <el-input v-model="processForm.contact" disabled></el-input>
                </el-form-item>
                <el-form-item label="问题描述">
                    <el-input 
                        v-model="processForm.problemDescription" 
                        type="textarea" 
                        :rows="3" 
                        disabled>
                    </el-input>
                </el-form-item>
                <el-form-item label="主体名称">
                    <el-input v-model="processForm.subjectName" disabled></el-input>
                </el-form-item>
                <el-form-item label="咨询时间">
                    <el-input v-model="processForm.consultationTime" disabled></el-input>
                </el-form-item>
                <el-form-item label="处理结果" prop="result" required>
                    <el-input 
                        v-model="processForm.result" 
                        type="textarea" 
                        :rows="4" 
                        placeholder="请输入处理结果"
                        maxlength="500"
                        show-word-limit>
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="processDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitProcessForm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'ConsultationManage',
    data() {
        return {
            // 咨询列表数据
            consultationList: [],
            // 搜索关键词
            searchKeyword: '',
            // 状态筛选
            statusFilter: '',
            // 加载状态
            loading: false,
            // 分页数据
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            // 对话框显示状态
            dialogVisible: false,
            // 是否为查看模式
            isViewMode: false,
            // 对话框标题
            dialogTitle: '添加咨询',
            // 咨询表单数据
            consultationForm: {
                id: null,
                name: '',
                contact: '',
                problemDescription: '',
                subjectName: '',
                consultationTime: '',
                status: 0,
                 result: '' // 新增：处理结果字段
            },
            // 表单验证规则
            rules: {
                name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                    { min: 2, max: 20, message: '姓名长度在2到20个字符', trigger: 'blur' }
                ],
                contact: [
                    { required: true, message: '请输入联系方式', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$|^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/, message: '请输入正确的手机号或邮箱', trigger: 'blur' }
                ],
                problemDescription: [
                    { required: true, message: '请输入问题描述', trigger: 'blur' },
                    { min: 10, max: 500, message: '问题描述长度在10到500个字符', trigger: 'blur' }
                ],
                subjectName: [
                    { required: true, message: '请输入主体名称', trigger: 'blur' }
                ],
                consultationTime: [
                    { required: true, message: '请选择咨询时间', trigger: 'change' }
                ]
            },
            // 处理咨询对话框显示状态
            processDialogVisible: false,
            // 处理咨询表单数据
            processForm: {
                id: null,
                name: '',
                contact: '',
                problemDescription: '',
                subjectName: '',
                consultationTime: '',
                result: ''
            },
            // 处理表单验证规则
            processRules: {
                result: [
                    { required: true, message: '请输入处理结果', trigger: 'blur' },
                    { min: 5, max: 500, message: '处理结果长度在5到500个字符', trigger: 'blur' }
                ]
            }

        }
    },
    created() {
        this.fetchConsultationList()
    },
    methods: {
        // API调用：获取咨询列表（根据关键词）
        async fetchConsultationList() {
            this.loading = true
            try {
                const params = {
                    keyword: this.searchKeyword,
                    currPage: this.pagination.currentPage,
                    pageSize: this.pagination.pageSize
                }
                
                const response = await this.$axios.get('/web/consultation/list', { params })
                console.log('获取咨询列表响应:', response.data)

                if (response.data) {
                    this.consultationList = response.data.list || []
                    this.pagination.total = response.data.total || 0
                } else {
                    this.$message.error('获取咨询列表失败')
                }
            } catch (error) {
                console.error('获取咨询列表失败:', error)
                this.$message.error('获取咨询列表失败')
            } finally {
                this.loading = false
            }
        },

        // API调用：根据状态获取咨询列表
        async fetchConsultationByStatus() {
            this.loading = true
            try {
                const params = {
                    state: parseInt(this.statusFilter),
                    currPage: this.pagination.currentPage,
                    pageSize: this.pagination.pageSize
                }
                
                const response = await this.$axios.get('/web/consultation/queryByState', { params })
                console.log('根据状态获取咨询列表响应:', response.data)

                if (response.data) {
                    this.consultationList = response.data.list || []
                    this.pagination.total = response.data.total || 0
                } else {
                    this.$message.error('根据状态获取咨询列表失败')
                }
            } catch (error) {
                console.error('根据状态获取咨询列表失败:', error)
                this.$message.error('根据状态获取咨询列表失败')
            } finally {
                this.loading = false
            }
        },

        // API调用：获取单个咨询
        async getConsultationById(id) {
            try {
                const response = await this.$axios.get('/web/consultation/queryById', {
                    params: { id }
                })
                console.log('获取咨询详情响应:', response.data)
                return response.data
            } catch (error) {
                console.error('获取咨询详情失败:', error)
                throw error
            }
        },

        // API调用：创建咨询
        async createConsultation(data) {
            try {
                const requestData = {
                    name: data.name,
                    contact: data.contact,
                    problemDescription: data.problemDescription,
                    subjectName: data.subjectName,
                    consultationTime: data.consultationTime,
                    status: 0 // 默认未处理
                }
                console.log('创建咨询请求参数:', requestData)

                const response = await this.$axios.post('/web/consultation/save', requestData)
                console.log('创建咨询响应:', response.data)
                return response.data
            } catch (error) {
                console.error('创建咨询失败:', error)
                throw error
            }
        },

        // API调用：处理咨询
        async handleConsultation(id, result) {
            try {
                const response = await this.$axios.put('/web/consultation/handle', null, {
                    params: { 
                        id: id,
                        result: result
                    }
                })
                console.log('处理咨询响应:', response.data)
                return response.data
            } catch (error) {
                console.error('处理咨询失败:', error)
                throw error
            }
        },

                // 提交处理表单
        submitProcessForm() {
            this.$refs.processForm.validate(async (valid) => {
                if (valid) {
                    try {
                        const response = await this.handleConsultation(this.processForm.id, this.processForm.result)
                        if (response.status === 200) {
                            this.$message.success('处理成功')
                            this.processDialogVisible = false
                            // 重新加载当前列表
                            if (this.statusFilter !== '') {
                                this.fetchConsultationByStatus()
                            } else {
                                this.fetchConsultationList()
                            }
                        } else {
                            this.$message.error(response.msg || '处理失败')
                        }
                    } catch (error) {
                        console.error('处理咨询失败:', error)
                        this.$message.error('处理失败')
                    }
                }
            })
        },
        // 处理对话框关闭处理
        handleProcessDialogClose() {
            if (this.$refs.processForm) {
                this.$refs.processForm.resetFields()
            }
            this.processForm = {
                id: null,
                name: '',
                contact: '',
                problemDescription: '',
                subjectName: '',
                consultationTime: '',
                result: ''
            }
        },


        // 搜索咨询
        handleSearch() {
            this.pagination.currentPage = 1
            if (this.statusFilter !== '') {
                // 如果选择了状态，则使用状态查询接口
                this.fetchConsultationByStatus()
            } else {
                // 否则使用关键词查询接口
                this.fetchConsultationList()
            }
        },

        // 状态筛选改变
        handleStatusChange() {
            this.pagination.currentPage = 1
            if (this.statusFilter !== '') {
                // 如果选择了状态，则使用状态查询接口
                this.fetchConsultationByStatus()
            } else {
                // 如果取消状态筛选，则使用关键词查询接口
                this.fetchConsultationList()
            }
        },

        // 重置搜索
        resetSearch() {
            this.searchKeyword = ''
            this.statusFilter = ''
            this.pagination.currentPage = 1
            this.fetchConsultationList()
        },

        // 打开添加咨询对话框
        handleAddConsultation() {
            this.isViewMode = false
            this.dialogTitle = '添加咨询'
            this.consultationForm = {
                id: null,
                name: '',
                contact: '',
                problemDescription: '',
                subjectName: '',
                consultationTime: this.getCurrentTime(),
                status: 0
            }
            this.dialogVisible = true
        },

        // 查看咨询详情
        async handleView(consultation) {
            this.isViewMode = true
            this.dialogTitle = '咨询详情'
            
            try {
                const response = await this.getConsultationById(consultation.id)
                if (response.status === 200) {
                    this.consultationForm = {
                        id: response.object.id,
                        name: response.object.name,
                        contact: response.object.contact,
                        problemDescription: response.object.problemDescription,
                        subjectName: response.object.subjectName,
                        consultationTime: response.object.consultationTime,
                        status: response.object.status,
                        result: response.object.result || '' // 新增：获取处理结果
                    }
                    this.dialogVisible = true
                } else {
                    this.$message.error(response.msg || '获取咨询详情失败')
                }
            } catch (error) {
                console.error('获取咨询详情失败:', error)
                this.$message.error('获取咨询详情失败')
            }
        },


        // 处理咨询（打开处理对话框）
        handleProcess(consultation) {
            // 填充处理表单数据
            this.processForm = {
                id: consultation.id,
                name: consultation.name,
                contact: consultation.contact,
                problemDescription: consultation.problemDescription,
                subjectName: consultation.subjectName,
                consultationTime: consultation.consultationTime,
                result: ''
            }
            this.processDialogVisible = true
        },


        // 提交咨询表单
        submitConsultationForm() {
            this.$refs.consultationForm.validate(async (valid) => {
                if (valid) {
                    try {
                        // 添加咨询
                        const response = await this.createConsultation(this.consultationForm)
                        if (response.status === 200) {
                            this.$message.success('添加成功')
                            this.dialogVisible = false
                            // 重新加载当前列表
                            if (this.statusFilter !== '') {
                                this.fetchConsultationByStatus()
                            } else {
                                this.fetchConsultationList()
                            }
                        } else {
                            this.$message.error(response.msg || '添加失败')
                        }
                    } catch (error) {
                        console.error('操作失败:', error)
                        this.$message.error('操作失败')
                    }
                }
            })
        },

        // 对话框关闭处理
        handleDialogClose() {
            this.$refs.consultationForm.resetFields()
            this.consultationForm = {
                id: null,
                name: '',
                contact: '',
                problemDescription: '',
                subjectName: '',
                consultationTime: '',
                status: 0
            }
        },

        // 获取当前时间
        getCurrentTime() {
            const now = new Date()
            const year = now.getFullYear()
            const month = String(now.getMonth() + 1).padStart(2, '0')
            const day = String(now.getDate()).padStart(2, '0')
            const hours = String(now.getHours()).padStart(2, '0')
            const minutes = String(now.getMinutes()).padStart(2, '0')
            const seconds = String(now.getSeconds()).padStart(2, '0')
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
        },

        // 分页大小改变
        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.pagination.currentPage = 1
            if (this.statusFilter !== '') {
                this.fetchConsultationByStatus()
            } else {
                this.fetchConsultationList()
            }
        },

        // 当前页改变
        handleCurrentChange(val) {
            this.pagination.currentPage = val
            if (this.statusFilter !== '') {
                this.fetchConsultationByStatus()
            } else {
                this.fetchConsultationList()
            }
        }
    }
}
</script>

<style scoped>
.consultation-manage {
    padding: 20px;
}

.box-card {
    min-height: calc(100vh - 100px);
}

.search-area {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both;
}

.el-table {
    margin-top: 20px;
}

.el-button+.el-button {
    margin-left: 10px;
}

.problem-description-preview {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.pagination-container {
    margin-top: 20px;
    text-align: right;
}
</style>